import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  hours?: number;
  minutes?: number;
  seconds?: number;
  className?: string;
}
export function CountdownTimer({
  hours = 2,
  minutes = 0,
  seconds = 0,
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours,
    minutes,
    seconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        if (newHours < 0) {
          // Reset timer when it reaches 0
          return {
            hours,
            minutes,
            seconds
          };
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [hours, minutes, seconds]);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className={`inline-flex items-center gap-2 bg-red-50 border border-red-200 rounded-full px-4 py-2 ${className}`} data-id="element-15">
      <Clock className="w-4 h-4 text-red-500" data-id="element-16" />
      <span className="text-sm font-medium text-red-600" data-id="element-17">
        ¡Oferta termina en:
      </span>
      <div className="flex items-center gap-1 font-bold text-red-700" data-id="element-18">
        <motion.span key={timeLeft.hours} initial={{
        scale: 1.2
      }} animate={{
        scale: 1
      }} className="bg-red-100 px-2 py-0.5 rounded" data-id="element-19">
          {formatNumber(timeLeft.hours)}
        </motion.span>
        <span data-id="element-20">:</span>
        <motion.span key={timeLeft.minutes} initial={{
        scale: 1.2
      }} animate={{
        scale: 1
      }} className="bg-red-100 px-2 py-0.5 rounded" data-id="element-21">
          {formatNumber(timeLeft.minutes)}
        </motion.span>
        <span data-id="element-22">:</span>
        <motion.span key={timeLeft.seconds} initial={{
        scale: 1.2
      }} animate={{
        scale: 1
      }} className="bg-red-100 px-2 py-0.5 rounded" data-id="element-23">
          {formatNumber(timeLeft.seconds)}
        </motion.span>
      </div>
    </motion.div>;
}